/* Keep the Shrine cart authoritative when the cloned Brooklyn PDP is loaded. */
(function () {
  'use strict';
  if (window.KD_CART_SYNC) return;

  function restoreQuantityInputs() {
    document.querySelectorAll('cart-drawer quantity-input, cart-items quantity-input').forEach(function (quantity) {
      var wrapper = quantity.querySelector('.js-qty');
      // Brooklyn replaced this input after Shrine bound its handlers. Reuse the
      // original element so type=number, data-index and its listeners all survive.
      if (wrapper && quantity.input && !quantity.input.isConnected) {
        wrapper.replaceWith(quantity.input);
        if (quantity.validateQtyRules) quantity.validateQtyRules();
      }
    });
  }

  var pending = null;
  function refresh() {
    if (pending) return pending;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return Promise.resolve();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var sectionsUrl = new URL(window.location.href);
    sectionsUrl.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
    sectionsUrl.searchParams.set('_kd_cart', String(Date.now()));
    pending = Promise.all([
      fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('Cart could not be loaded');
        return r.json();
      }),
      fetch(sectionsUrl.toString(), { cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('Cart sections could not be loaded');
        return r.json();
      })
    ]).then(function (results) {
      var cart = results[0], sections = results[1];
      if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) {
        throw new Error('Cart sections are missing');
      }
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      drawer.renderContents({ id: cart.items[0] && cart.items[0].id, sections: sections }, true);
      restoreQuantityInputs();
      return cart;
    }).finally(function () { pending = null; });
    return pending;
  }
  function syncQuietly() {
    return refresh().catch(function (error) { console.warn('[Kokochi cart]', error); });
  }

  function start() {
    restoreQuantityInputs();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.kdOpenWithSync && typeof drawer.open === 'function') {
      var originalOpen = drawer.open;
      drawer.open = function (trigger) {
        var self = this;
        return syncQuietly().then(function () { originalOpen.call(self, trigger); });
      };
      drawer.kdOpenWithSync = true;
    }
    document.querySelectorAll('cart-drawer, cart-items').forEach(function (cart) {
      new MutationObserver(restoreQuantityInputs).observe(cart, { childList: true, subtree: true });
    });
    syncQuietly();
  }

  window.KD_CART_SYNC = { refresh: refresh, restoreQuantityInputs: restoreQuantityInputs };
  // Includes checkout -> Back with the browser's back/forward page cache.
  window.addEventListener('pageshow', syncQuietly);
  function ready() { customElements.whenDefined('cart-drawer').then(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
